import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import companyService from '../../services/company.service';
import "./CompanyReport.css"; 

const CompanyReport = () => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchReportData = async () => {
      try {
        setLoading(true);
        const res = await companyService.getAllCompanies();
        setCompanies(res.data || []);
      } catch (err) {
        console.error('Error loading data');
      } finally {
        setLoading(false);
      }
    };
    fetchReportData();
  }, []);

  const handleViewDashboard = (company) => {
    navigate(`/company-report/${company.id}`, { state: { company } });
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="report-containers">
      <h1 className="report-titles">Company Operational Report</h1>
      
      <div className="table-wrappers">
        <table className="custom-tables">
          <thead>
            <tr>
              <th>Company Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {companies.map((company) => (
              <tr key={company.id}>
                <td style={{fontWeight: '600', paddingLeft: '20px'}}>{company.name}</td>
                <td>
                  <button 
                    className="action-btns" 
                    onClick={() => handleViewDashboard(company)}
                  >
                    View Report
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CompanyReport;